import { mapState } from 'vuex';
import f from "@/application/shared/functions.js";

export default {
    name: 'chat_preview',
    props: {
        chat : Object
    },

    data : function(){

        return {
            loading : false
        }

    },

    created() {
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        anotherMembers : function(){

            var me = this.core.user.info.userinfo.id

            return _.map(_.filter(this.chat.members, (m) => {
                return m.data.userId != me
            }), (m) => {
                return m.data.userId
            })

        },

        lastEvent : function(){
            return _.filter(this.chat.events, (m) => {
                return m.type == 'message'
            })[0]
        },

        vmessage : function(){

            if(this.lastEvent.type == 'message') {
                if(this.lastEvent.data.type == 'message' || this.lastEvent.data.type == 'system') {
                    return f.convertNewLinesToBr(f.superXSS(this.lastEvent.data.text))
                }
            }

            return ''
        },
    }),

    methods : {
        
    },
}